import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgbCalendar, NgbDate, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, finalize, takeUntil, tap } from 'rxjs/operators';

import { AppConfig, ExcelService, PreviousRouteService, ParameterData, DataService, WindowService, CustomDatepickerI18n } from '../../../../_helpers/index';
import { CustomerService, DebtorService, InvoicesService, BackFilterService, DebtorDataService, ExcelDateConvertService, PayoutService, UserService, I18n, AuthService } from '../../../../_services';
import { Status, Overduedate, ExpirationRank, Creation } from '../../../../_enums/invoice';
import { BatchProcessUrls } from '../../../../_enums/urls';
import { InvoiceReportExport, QueryParamsList, User } from '../../../../_models';

import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { ErrorTableMessage, NoDataTableMessage } from './corporate-invoice-list.constants';

@Component({
  selector: 'app-new-corporate-invoice-list',
  templateUrl: './new-invoices-list.component.html',
  styleUrls: ['./new-invoices-list.component.css', '../../../../../assets/css/new-component-view.css', '../../../../../assets/css/new-invoice-list-table.css', '../../../../sharedcomp/sidebar/sidebar.component.css', '../../../../../assets/css/new-date-range-picker.css', '../../../../../assets/css/new-buttons-theme.css'],
  animations: [
    trigger('animationSplit', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(400px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 1, transform: 'translateX(500px)' })),
      ]),
    ]),
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(200, style({ opacity: 1 })),
      ]),
    ])
  ],
  providers: [I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})
export class NewCorporateInvoiceListComponent implements OnInit, OnDestroy, AfterViewInit {

  public customer_public_id: string;

  excelExportData: any;
  totalSize: any;
  excelExportDataNew: any;
  ddlStatus: any[];
  ddlExpirationPRank: any[];
  ddlExpirationRank: any[];
  ddlCreation: any[];

  public pageStartDate: any;
  public pageEndDate: any;


  public gmtZeroID = false;
  public gmtNonZeroID = false;

  searchFilterForm: FormGroup;
  public displayedColumns: string[] = ['corporate-debtor.name', 'corporate-creditor.name', 'corporate-status', 'corporate-total.value', 'corporate-created', 'corporate-due_datetime', 'corporate-actions'];
  public displayedEmptyColumn: string[] = ['empty-row'];
  public dataSourceInvoicesList = new MatTableDataSource();
  public emptyData = new MatTableDataSource([{ empty: "row" }]);
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  isRangoVisiable = false;
  isExpirationVisiable = false;
  isOverdueVisiable = false;
  isRangoStatus = "None";
  auth0Profile: any;
  pageSize: any;
  pageIndex: number = 0;
  pageStart: number = 0;
  PageSizeOptions: number[];
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  tempInvoiceStatus: string;
  anularDis = false;
  isCreateAvailable = false;
  isExportExcelAvailable = true;
  isImportAvailable = true;
  isUpdateAvailable = true;
  isDeleteAvailable = true;
  isRejectAvailable = true;
  isReadAvailable = true;
  searchValue: any;
  statusDropdownValue = 0;
  creationDropdownValue = 3;
  statusFormControl = new FormControl(0);
  creationFormControl = new FormControl(0);
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  queryParams: QueryParamsList = {};
  snapshotQueryParam: QueryParamsList = {};
  startDateFromSnapshotQueryParam: boolean = false;
  endDateFromSnapshotQueryParam: boolean = false;

  baseURL: string;
  timerId: any;
  isExportDataAvailable:  undefined | InvoiceReportExport;
  isErrorExportAvailable: object | undefined;
  timeCompleted: boolean = false;
  exportSubscription$ : Subscription;
  configurationDetails: any;

  showOverlay: boolean = false;
  displayMonths: number;
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  icons: Record<string, Record<string, string>>;

  private destroy$ = new Subject<void>();
  public isTableLoading: boolean = false;
  public showRetryBtn: boolean = false;
  public readonly noDataTableMessage = NoDataTableMessage;
  public readonly errorTableMessage = ErrorTableMessage;

  /** This is Constructor function which is used to initialize the class variables and objects;
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder
      , private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService, private debtorService: DebtorService
      , private invoicesService: InvoicesService
      , private creation: Creation
      , private expirationRank: ExpirationRank
      , private overduedate: Overduedate
      , private status: Status
      , private datePipe: DatePipe
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private titleService: Title
      , private payoutService: PayoutService
      , private backFilterService:BackFilterService
      , private previousRouteService:PreviousRouteService
      , private currencyPipe: CurrencyPipe
      , private excelDateConvertService:ExcelDateConvertService
      , private activatedRoute: ActivatedRoute
      , private windowService: WindowService
    ) {
    this.icons = icons;
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.ddlCreation = this.creation._newCreation;
    this.ddlStatus = status._status;
    this.initSearchForm();
    this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V2;
  }

  ngOnInit() {
    this.checkThisPageGrants();
    let companyIdStorage = localStorage.getItem('companyId');
    let browserStorage1 = (localStorage.getItem('isCorporate') === 'undefined') ? null : localStorage;

    if (browserStorage1 != null && (companyIdStorage != null || companyIdStorage !== '')) {
      this.customer_public_id = companyIdStorage;
    } else {
      this.router.navigate(['/home']);
    }

    let browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;

    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;

    } else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }

    this.displayMonths = window.innerWidth > 900 ? 2 : 1;
    this.listenWindowWidth();

    this.tempInvoiceStatus = 'all';
    this.pageStartDate = this.setTodayValueFilter('00:00:00');
    this.pageEndDate = this.setTodayValueFilter('23:59:59');
    this.searchValue = '';

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "Siguiente página";
    this.paginator._intl.lastPageLabel = "Ultima página";
    this.paginator._intl.previousPageLabel = "Anterior página";
    this.paginator._intl.firstPageLabel = "Primera página";
    this.getCorporateInvoiceList();
  }

  public getInvoiceList(pageStart: number = 0, resetPageIndex: boolean = false): void {
    this.isTableLoading = true;
    this.showBtn(false);
    this.dataSourceInvoicesList.data = [];

    this.invoicesService.getInvoiceList(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate, this.pageEndDate, this.pageSize, pageStart, this.searchValue)
    .pipe(
      takeUntil(this.destroy$),
      tap(data => {
        try {
          let resources = data["data"];
          if (resetPageIndex) {
            this.paginator.pageIndex = 0;
          }
          this.selection.clear();
          this.dataSourceInvoicesList.data = resources;
          this.totalSize = JSON.parse(data.records);
        } catch (error) {
          console.error(error);
          this.showBtn(true);
        }
      }),
      finalize(() => {
        this.isTableLoading = false;
      }),
      catchError(error => {
        console.error('Failed! while trying to get the invoices list. ' + error.error);
        this.showBtn(true);
        throw error;
      })
    )
    .subscribe();
  }

  public reloadTable($event: void): void {
    this.getInvoiceList(this.pageStart);
  }

  public showBtn(value: boolean) {
    this.showRetryBtn = value;
  }

  initSearchForm() {
    this.searchFilterForm = this.formBuilder.group({
      searchText: [this.searchValue, Validators.required]
    });
  }

  listenWindowWidth() {
    this.windowService.resizeObservable$
      .pipe(
        debounceTime(200),
        takeUntil(this.destroy$)
      )
      .subscribe((e: Event) => {
        this.displayMonths = e.target['innerWidth'] > 900 ? 2 : 1;
      });
  }

  toggleDateRangePicker() {
    this.showOverlay = !this.showOverlay;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isDisabled(date: NgbDate, current: {month: number}) {
    return date.month === current.month;
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  isFromDate(date: NgbDate) {
    return date.equals(this.fromDate);
  }

  isToDate(date: NgbDate) {
    return this.toDate && date.equals(this.toDate);
  }

  selectDateOption(option: number) {
    this.creationFormControl.patchValue(option);
    this.showOverlay = !this.showOverlay;
    if (option !== 9) {
      this.fromDate = null;
      this.toDate = null;
    }
    this.filterCreationDetails(option);
  }

  get filterStatusName(): string {
    const filterStatus = this.ddlStatus.find(item => item.value === this.statusFormControl.value);
    return filterStatus ? filterStatus.name : '';
  }

  selectStatusOption(option: number) {
    this.showOverlay = false;
    this.statusFormControl.patchValue(option);
    this.filterStatusDetails(option);
  }

  applyFilter() {
    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.searchValue = this.filterValue.toLowerCase().trim();
    this.getCorporateInvoicesListFilterAndSearch();
  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit(){
    this.dataSourceInvoicesList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourceInvoicesList.sort = this.sort;
  }

  getCorporateInvoicesListFilterAndSearch() {
    this.pageIndex = 0;
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize = this.pageSize;
    this.queryParams.startDate = this.pageStartDate;
    this.queryParams.endDate = this.pageEndDate;
    this.queryParams.status = this.tempInvoiceStatus;
    if (this.searchValue != '') {
      this.queryParams.textSearch = this.searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.pageEvent(this.queryParams);
  }

  getCorporateInvoiceList() {
    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length != 0) {
      let creationStateCorporateInvoiceList = JSON.parse(localStorage.getItem('creationStateCorporateInvoiceList'));
      let customCreationCorporateInvoiceRange = JSON.parse(localStorage.getItem('customCreationCorporateInvoiceRange'));

      if (this.snapshotQueryParam["pageIndex"] != undefined) {
        if(this.snapshotQueryParam["pageIndex"] !== ''){
          this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
        } else {
          this.queryParams.pageIndex = this.pageIndex.toString();
        }
      };

      if (this.snapshotQueryParam["pageSize"] != undefined) {
        if(this.snapshotQueryParam["pageSize"] !== '') {
          this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
        } else {
          this.queryParams.pageSize = this.pageSize.toString();
        }
      };

      if(this.snapshotQueryParam["startDate"] != undefined || this.snapshotQueryParam["endDate"] != undefined) {
        if(this.snapshotQueryParam["startDate"] !== '') {
          this.startDateFromSnapshotQueryParam = true;
          this.queryParams.startDate = this.snapshotQueryParam["startDate"].replace(' ', '-');
        } else {
          this.queryParams.startDate = this.pageStartDate;
        }

        if(this.snapshotQueryParam["endDate"] !== '') {
          this.endDateFromSnapshotQueryParam = true;
          this.queryParams.endDate = this.snapshotQueryParam["endDate"].replace(' ', '-');
        } else {
          this.queryParams.endDate = this.pageEndDate;
        }

        if (creationStateCorporateInvoiceList === 9) {
          this.creationFormControl.setValue(9);
          this.fromDate = customCreationCorporateInvoiceRange.fromDate;
          this.toDate = customCreationCorporateInvoiceRange.toDate;
        } else {
          this.creationFormControl.setValue(creationStateCorporateInvoiceList);
        }
      };

      if (this.snapshotQueryParam["status"] != undefined) {
        this.queryParams.status = this.snapshotQueryParam["status"];
        this.setStatusFormBySnapshotQueryParam(this.queryParams.status);
      };

      if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] != '') {
        this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
        this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
      };

      this.pageEvent(this.queryParams);
    } else {
        localStorage.setItem('creationStateCorporateInvoiceList', '0');
        this.getInvoiceList(this.pageStart, true);
    }
  }

  pageEvent(event) {
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    if(event["startDate"]){
      if(this.startDateFromSnapshotQueryParam) {
        this.queryParams.startDate = event["startDate"];
        this.pageStartDate = this.replaceAt(10, event["startDate"], ' ');
        this.startDateFromSnapshotQueryParam = false;
      } else {
        this.pageStartDate = event["startDate"];
        this.queryParams.startDate = event["startDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.startDate = this.pageStartDate;
      this.queryParams.startDate = this.queryParams.startDate.replace(' ', '-');
    }

    if(event["endDate"]){
      if(this.endDateFromSnapshotQueryParam) {
        this.queryParams.endDate = event["endDate"];
        this.pageEndDate = this.replaceAt(10, event["endDate"], ' ');
        this.endDateFromSnapshotQueryParam = false;
      } else {
        this.pageEndDate = event["endDate"];
        this.queryParams.endDate = event["endDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.endDate = this.pageEndDate;
      this.queryParams.endDate = this.queryParams.endDate.replace(' ', '-');
    }

    if(event["status"]){
      this.queryParams.status = event["status"];
      this.tempInvoiceStatus = this.queryParams.status;
    } else {
      this.queryParams.status = this.tempInvoiceStatus;
    }

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      skipLocationChange: false,
      replaceUrl: true
    });

    this.getInvoiceList(this.pageStart);
  }

  setStatusFormBySnapshotQueryParam(status) {
    const statusMap = {
      'all': 0,
      '(1)': 1,
      '(3)': 2,
      '(4)': 3,
      '(5)': 4,
      '(6)': 6,
      '(8)': 5,
      '(10)': 7,
      '(11)': 8,
      '(12)': 9,
      '(15)': 10,
      '(16)': 11,
      '(17)': 12,
    };
    this.statusFormControl.setValue(statusMap[status] || 0);
  }

  replaceAt(index, textToReplace, character) {
    let chars = textToReplace.split('');
    chars[index] = character;
    return chars.join('');
  }

   filterStatusDetails(status) {
    const statusMapping = {
      [this.ddlStatus[0].value]: 'all',
      [this.ddlStatus[1].value]: '(1)',
      [this.ddlStatus[2].value]: '(3)',
      [this.ddlStatus[3].value]: '(4)',
      [this.ddlStatus[4].value]: '(5)',
      [this.ddlStatus[5].value]: '(8)',
      [this.ddlStatus[6].value]: '(6)',
      [this.ddlStatus[7].value]: '(10)',
      [this.ddlStatus[8].value]: '(11)',
      [this.ddlStatus[9].value]: '(12)',
      [this.ddlStatus[10].value]: '(15)',
      [this.ddlStatus[11].value]: '(16)',
      [this.ddlStatus[12].value]: '(17)',
    };

    this.tempInvoiceStatus = statusMapping[status] || '';
    this.getCorporateInvoicesListFilterAndSearch();
  }

  /** This function is used to filter the invoices list based on Creation details based;
  *   it accepts the param select Creation Date values
  */
  filterCreationDetails(creation) {
    localStorage.setItem('creationStateCorporateInvoiceList', creation.toString());

    const currentDate = new Date();

    const currentweekFirstDate = new Date();
    const currentweekLastDate = new Date();
    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    const lastweekFirstDate = new Date();
    const lastweekLastDate = new Date();
    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

    const currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    const currentYearFirstDate = new Date(currentDate.getFullYear(), 0, 1);
    const currentYearLastDate = new Date(currentDate.getFullYear(), 11, 31);

    const lastYearFirstDate = new Date(currentDate.getFullYear() - 1, 0, 1);
    const lastYearLastDate = new Date(currentDate.getFullYear() - 1, 11, 31);

    let startDateVar;
    let endDateVar;

    switch (Number(creation)) {
      case 0: {
        // Today Filter Condition
        currentDate.setDate(currentDate.getDate());
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      }
      case 1:
        // Yesterday Filter Condition
        currentDate.setDate(currentDate.getDate() - 1);
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 2:
        // Current Week Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 3:
        // Last Week Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 4:
        // Current Month Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 5:
        // Last Month Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 6:
        // Current Year Filter Condition
        startDateVar = this.convertGMTTime(new Date((formatDate(currentYearFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(currentYearLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        break;
      case 7:
        // Last Year Filter Condition
        startDateVar = this.convertGMTTime(new Date((formatDate(lastYearFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(lastYearLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        break;
      case 8: {
        // All Datas Condition
        startDateVar = '2017-01-01';
        endDateVar = '2030-01-01';
        break;
      }
      case 9: {
        // Custom Filter Condition
        const startDatePicker = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
        const endDatePicker = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
        startDateVar = this.convertGMTTime(new Date((formatDate(startDatePicker, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(endDatePicker, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        const filterValue = {
          fromDate: this.fromDate,
          toDate: this.toDate
        };
        localStorage.setItem('customCreationCorporateInvoiceRange', JSON.stringify(filterValue));
        break;
      }
      default:
        startDateVar = this.setTodayValueFilter('00:00:00');
        endDateVar = this.setTodayValueFilter('23:59:59');
        break;
    }
    this.pageStartDate = startDateVar;
    this.pageEndDate = endDateVar;
    this.getCorporateInvoicesListFilterAndSearch();
  }

  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    } else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  /**
  * this function is used to redirect to the right component based on input.
  */
  invoicegridActionClick(viewtype, publicid) {

    switch (viewtype) {
      case 'invoiceview':
        this.router.navigate([`/corporate/invoices/${publicid}/view`]);
        break;
      case 'invoiceedit':
        this.router.navigate([`/corporate/invoices/${publicid}/edit`]);
        break;

      case 'invoicedelete':
        this.onConfirmInvoice(publicid);

        break;

      case 'invoicedupicate':
        this.duplicateInvoiceDetails(publicid);
        break;
      case 'invoicereject':
        this.rejectInvoice(publicid);
        break;
      default:
        this.router.navigate([`/corporate/invoices/${publicid}/view`]);

    }//end switch

  }

  rejectInvoice(publicid) {
  }

  duplicateInvoiceDetails(publicid) {

    this.parameterData.InvoiceIdParameters = publicid;
    this.router.navigate(['/invoices/create']);
  }

  /**
* this function is used to get the cancel the Invoice Details .
*/
  onConfirmInvoice(publicid) {
    this.invoicesService.deleteInvoice(publicid)
      .subscribe((result) => {
        this.getCorporateInvoiceList();
      }, error => {
        console.error('Failed while trying to cancel the invoice Details.' + error);
      });
  }

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == undefined && this.isErrorExportAvailable == undefined) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 11000);
  }

  reportExport() {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;
    this.checkResponseExportTime();

    this.exportSubscription$ = this.invoicesService.reportExport(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate,
      this.pageEndDate, this.searchValue).subscribe(data => {
      this.isExportDataAvailable = data;
      if (data.storage_url != undefined) {
        location.href = data.storage_url;
      }
      this.spinnerService.hide();
    }, err => {
      this.spinnerService.hide();
      this.isErrorExportAvailable = err;
      console.error('Failed while trying to export txt file.' + err.error);
    });
  }

  closeModal() {
    this.timeCompleted = false;
  };

  viewDashboard(element) {
    localStorage.setItem('isCorporateCompany', "Yes");
    localStorage.removeItem('accessmenu');
    this.GetSubCompanyName(element);
    localStorage.setItem('subcompanyId', element.creditor.public_id);
    this.router.navigate([`/dashboardcallback`]);
  }//end

  GetSubCompanyName(element) {

    this.customerService.getCustomerCompanyDetailsList(element.creditor.public_id).subscribe(d => {
      localStorage.setItem('isCorporate', 'Yes');
      localStorage.setItem('customername', d.body.name);
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));
    },
      error => {

      });

  }

  async checkThisPageGrants() {
    await this.auth.isKashioGrantsAvailable();
    this.isCreateAvailable = this.auth.checkGrants('INVOICES', 'CREATE');
    this.isExportExcelAvailable = this.auth.checkGrants('INVOICES', 'EXPORT');
    this.isImportAvailable = this.auth.checkGrants('INVOICES', 'IMPORT');
    this.isUpdateAvailable = this.auth.checkGrants('INVOICES', 'UPDATE');
    this.isDeleteAvailable = this.auth.checkGrants('INVOICES', 'DELETE');
    this.isRejectAvailable = this.auth.checkGrants('INVOICES', 'REJECT');
    this.isReadAvailable = this.auth.checkGrants('INVOICES', 'READ');
  }

  setTodayValueFilter(hour: string) {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    var todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
